module.exports = __webpack_public_path__ + "static/media/AoA_RaceGameEnvShot_09.ffc9bb0b.jpg";